{
	"titleFirstPart": "Witamy w",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Łączna ilość zmagazynowanego dwutlenku węgla"
}
